import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    stateName: "",
    cityName: "",
}

const deliverySlice = createSlice({
    name: "delivery",
    initialState,
    reducers: {
        setStateName: (state, action) => {
            state.stateName = action.payload;
        },
        setCityName: (state, action) => {
            state.cityName = action.payload;
        },
        resetAllFilters: (state) => {
            state.stateName = initialState.stateName;
            state.cityName = initialState.cityName;
        }
    }
});

export const {
    setStateName,
    setCityName,
    resetAllFilters
} = deliverySlice.actions;

export default deliverySlice.reducer;

